import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("详情");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("关闭");

import { computed, reactive, ref, watch } from 'vue';
import { getActivityEditRecordList } from '@/request';
import { getVexTableProps } from '@/config';
import ActivityEditRecordDetailModal from './ActivityEditRecordDetailModal.vue';
export default {
  name: 'ActivityEditRecordListModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['update:modelValue'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const loading = ref(false);
    const tableData = ref([]);
    const detailModal = reactive({
      visible: false,
      recordId: undefined
    });
    const tableOptions = getVexTableProps({
      height: 360,
      toolbarConfig: {
        enabled: false
      },
      pagerConfig: {
        enabled: false
      },
      columnConfig: {
        resizable: false
      },
      columns: [{
        title: '更新时间',
        field: 'createAt',
        minWidth: 160
      }, {
        title: '修改人',
        field: 'createBy',
        minWidth: 120,
        showOverflow: true
      }, {
        title: '更新备注',
        field: 'remark',
        minWidth: 200,
        showOverflow: true
      }, {
        title: '操作',
        slots: {
          default: 'operation'
        },
        width: 80,
        align: 'center'
      }]
    });
    watch(() => props.modelValue, val => {
      if (val) {
        loadRecordList();
      }
    });

    function loadRecordList() {
      var _props$row;

      if (!((_props$row = props.row) !== null && _props$row !== void 0 && _props$row.activityId)) {
        tableData.value = [];
        return;
      }

      loading.value = true;
      getActivityEditRecordList({
        activityId: props.row.activityId,
        __warn: true
      }).then(data => {
        tableData.value = data.rows || [];
      }).finally(() => {
        loading.value = false;
      });
    }

    function openDetail(row) {
      detailModal.recordId = row.recordId;
      detailModal.visible = true;
    }

    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(visible) ? visible.value = $event : null),
        title: "更新记录",
        width: "800px",
        "destroy-on-close": ""
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })]),
        default: _withCtx(() => [_unref(visible) ? (_openBlock(), _createBlock(_component_vxe_grid, _mergeProps({
          key: 0
        }, _unref(tableOptions), {
          data: tableData.value,
          loading: loading.value
        }), {
          operation: _withCtx(({
            row
          }) => [_createVNode(_component_el_button, {
            link: "",
            type: "primary",
            onClick: $event => openDetail(row)
          }, {
            default: _withCtx(() => [_hoisted_1]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        }, 16, ["data", "loading"])) : _createCommentVNode("", true), _createVNode(ActivityEditRecordDetailModal, {
          modelValue: detailModal.visible,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => detailModal.visible = $event),
          "record-id": detailModal.recordId
        }, null, 8, ["modelValue", "record-id"])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};